// Module
var code = `<div class="ps-detail-header">
  <button id="mll-exit-btn" class="btn btn-icon" title="Back to list">← Back</button>
  <span class="ps-detail-name">Labeling Queue</span>
  <div class="ps-detail-actions">
    <span id="mll-status" class="ps-status"></span>
  </div>
</div>

<div class="ps-body">
  <div class="ps-toolbar">
    <hs-toolbar-button id="mll-refresh-btn" class="ps-icon-btn" title="↻"></hs-toolbar-button>
    <label class="mll-filter-toggle"><input type="checkbox" id="mll-show-reviewed" /> Show reviewed</label>
  </div>
  <div class="mll-layout">
    <div class="mll-list" id="mll-list"></div>
    <div class="mll-detail" id="mll-detail"></div>
  </div>
  <div class="mll-datasets" id="mll-datasets"></div>
</div>
`;
// Exports
export default code;